import { algoliasearch } from 'algoliasearch';
import algoliasearchHelper, {
  type AlgoliaSearchHelper,
} from 'algoliasearch-helper';
import { CATALOG_MENU_HIERARCHY_NAME } from 'catalog-search-sdk/constants';
import type { AlgoliaProductHitAttribute } from 'catalog-search-sdk/types';
import { type QueryParams, QueryParamsSchema } from 'catalog-search-sdk/url';

import env from '~/env';

const searchClient = algoliasearch(env.ALGOLIA_APP_ID, env.ALGOLIA_API_KEY);

const searchClients: Record<string, AlgoliaSearchHelper> = {};

function searchClientHelper(indexName: string) {
  const current = searchClients[indexName];
  if (current) return current;
  const client = algoliasearchHelper(
    // @ts-expect-error god knows
    searchClient,
    indexName,
    {
      hierarchicalFacets: [
        {
          name: CATALOG_MENU_HIERARCHY_NAME,
          attributes: [
            'slug_hierarchy.lvl0',
            'slug_hierarchy.lvl1',
            'slug_hierarchy.lvl2',
          ] satisfies AlgoliaProductHitAttribute[],
        },
      ],
    },
  );

  searchClients[indexName] = client;

  return client;
}

function parseSearchParams(searchParams: URLSearchParams): QueryParams {
  return QueryParamsSchema.parse(Object.fromEntries(searchParams));
}

export { searchClient, searchClientHelper, parseSearchParams };
